import { CHART_SUMMARY_FAILURE, CHART_SUMMARY_PENDING, CHART_SUMMARY_SUCCESS } from '../../actions/types';

const initialState = {
    loading: false,
    data: {
        byEmployees: [],
        byProducts: [],
        byPracticeLocations: []
    },
    error: null
};

const chartReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHART_SUMMARY_PENDING:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CHART_SUMMARY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: {
                    byEmployees: action.payload.byEmployees || [],
                    byProducts: action.payload.byProducts || [],
                    byPracticeLocations: action.payload.byPracticeLocations || []
                },
                error: null
            };
        case CHART_SUMMARY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
};

export default chartReducer;